
import React from 'react'

import withLoading from 'helpers/withLoading'

import Visual from 'views/components/common/visual/index'

import Related from 'views/components/common/related/index'

import Section from './section'

import styles from './index.module.scss'


const MessageList = (props) => (
	<main className={styles.message}>

		<Visual {...props.payload} />

		<Section {...props.payload} />

		<Related {...props.payload} />

	</main>
)

export default withLoading(MessageList)
